export const opportunityProfileKeys = new Set([
  'legalEntityName',
  'dba',
  'entityType',
  'fein',
  'yearEstablished',
  'website',
  'primaryContactName',
  'primaryContactTitle',
  'primaryContactEmail',
  'primaryContactPhone',
  'businessOwnerName',
  'businessOwnerDob',
  'businessOwnerAddress',
  'mailingAddress',
  'numberOfLocations',
  'statesOfOperation',
  'detailedDescription',
  'naicsCode',
  'sicCode',
  'annualRevenue',
  'projectedRevenue',
  'employeesFullTime',
  'employeesPartTime',
  'estimatedAnnualPayroll',
  'independentContractorsUsed',
  'subcontractedRevenuePercent',
  'workOutsideUs',
  'manufacturesProducts',
  'professionalServicesProvided',
  'patientCareProvided',
  'coverageGeneralLiability',
  'coverageProperty',
  'coverageCommercialAuto',
  'coverageHiredNonOwnedAuto',
  'coverageWorkersComp',
  'coverageUmbrellaExcess',
  'coverageProfessionalLiability',
  'coverageCyber',
  'coverageDO',
  'coverageEPLI',
  'coverageCrime',
  'coverageInlandMarine',
  'coverageIntellectualProperty',
  'coverageCreditInsurance',
  'coverageFlood',
  'coveragePollution',
  'coverageBuildersRisk',
  'coverageForeignTravel',
  'coverageForeignLiability',
  'coverageVolunteerAccident',
  'coverageBond',
  'coverageLiquorLiability',
  'coverageOther',
  'desiredLimits',
  'reasonForMarketing',
  'priorClaims',
  'propertyOwnerType',
  'constructionType',
  'yearBuilt',
  'buildingSquareFootage',
  'occupiedSquareFootage',
  'roofTypeAge',
  'hvacUpdates',
  'sprinklered',
  'fireAlarmCentralStation',
  'burglarAlarmCentralStation',
  'businessPersonalPropertyValue',
  'buildingValue',
  'businessIncomeExposure',
  'docCurrentPolicies',
  'docShareholderAgreements',
  'docAutomobileSchedule',
  'docFiveYearLossRuns',
  'docMasterServiceAgreements',
  'docDriversList',
  'docCompletedApplications',
  'docStatementsOfWork',
  'docOrganizationalChart',
  'docIndependentContractorAgreements',
  'docExecutiveSummary',
  'docSubcontractorAgreements',
  'docPitchDecks',
  'docVendorAgreements',
  'docResumesCVs',
  'docStaffingAgreements',
  'docCurrentFinancials',
  'docLeaseAgreements',
  'docProformaFinancials',
  'docManufacturingAgreements',
  'docCapTable',
  'docPropertyScheduleCope',
  'owners',
  'entities',
  'locations'
]);
